import React from 'react';
import classNames from 'classnames/bind';
import { Button } from '@thinkific/toga-react';

import { routes } from 'utils/routerHelpers';

import { SCREEN_LG } from 'utils/constants';

import { useWindowSize } from 'hooks/useWindowSize';

import TrackingEvent, { TrackingProperty } from 'constants/trackingEvents';
import withDismissable from 'components/HOCs/Dismissable';
import { InjectedDismissableProps } from 'components/HOCs/Dismissable/Dismissable';
import { useTranslation } from 'react-i18next';
import { LocalStorageKeys } from 'constants/localStorageKeys';
import { useCommunityContext } from 'components/CommunityContext';
import InfoCard from 'components/InfoCard';
import MiniUserDetail from 'components/Upsells/InterestedMembers/components/MiniUserDetail';

import styles from './InterestedMembersUpsell.module.scss';

const cx = classNames.bind(styles);

export const UPGRADE_PROMPT_AVATAR_1 =
  'https://cdn.thinkific.com/90/20221129/773c20595e78c081f9a1b42ce2892530.png';
export const UPGRADE_PROMPT_AVATAR_2 =
  'https://cdn.thinkific.com/90/20221129/aaef1d4088f619886e9fc1f98d06e511.png';

const InterestedMembersUpsell: React.FC<InjectedDismissableProps> = ({
  onDismiss,
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useCommunityContext();

  const { width } = useWindowSize();
  const isMobile = width < SCREEN_LG;

  const onClick = (event) => {
    event.preventDefault();
    trackEvent(TrackingEvent.CLICK_UPGRADE_SUBSCRIPTION_LINK, {
      [TrackingProperty.COMPONENT]: 'InterestedMembersUpsell',
    });
    window.open(routes.subscription, '_blank');
  };

  const CustomWrapper: React.FC<{ children: React.ReactNode }> = ({
    children,
  }) => {
    return (
      <div className={cx('interested-members-upsell-wrapper')}>{children}</div>
    );
  };

  return (
    <div
      className={cx('interested-members-upsell', 'mb-2')}
      data-qa="interested-members-upsell"
    >
      <InfoCard
        title={t(
          'components-interestedMembersUpsell-title',
          'Interested Members'
        )}
        wrapper={CustomWrapper}
        isCompact
        isDismissable
        onClose={onDismiss}
      >
        <div>
          {t(
            'components-interestedMembersUpsell-upgrade_prompt_call_to_action',
            'Upgrade to track event RSVPs and email members about event updates.'
          )}
        </div>
        {!isMobile && (
          <div>
            <MiniUserDetail
              avatar={UPGRADE_PROMPT_AVATAR_1}
              userId="1"
              username="Courtney Henry"
            />
            <MiniUserDetail avatar="" userId="2" username="Diane Russel" />
            <MiniUserDetail
              avatar={UPGRADE_PROMPT_AVATAR_2}
              userId="3"
              username="Ronald Richards"
            />
          </div>
        )}
        <div className={cx('mt-2')}>
          <Button
            appearance="primary"
            className={cx('upgrade-prompt__upgrade-button')}
            isUpgrade
            onClick={onClick}
          >
            {t(
              'components-interestedMembersUpsell-upgrade_button',
              'UPGRADE NOW'
            )}
          </Button>
        </div>
      </InfoCard>
    </div>
  );
};

export default withDismissable(
  InterestedMembersUpsell,
  LocalStorageKeys.eventPageInterestedMembersUpsell
);
